<div class="space-y-6">
  <div class="flex items-center justify-between">
    <div>
      <h1 class="text-2xl font-bold text-gray-900">Analytics & Reports</h1>
      <p class="text-gray-600 mt-1">Insights and performance metrics</p>
    </div>
    <app-button variant="primary">
      <svg class="w-4 h-4 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
      Export Report
    </app-button>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
    <div class="card">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-sm font-medium text-gray-500">Total Appointments</h3>
        <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </div>
      <p class="text-3xl font-bold text-gray-900">{{ appointmentStats().total }}</p>
      <div class="mt-4 space-y-2">
        <div class="flex justify-between text-sm">
          <span class="text-gray-600">Scheduled</span>
          <span class="font-medium">{{ appointmentStats().scheduled }}</span>
        </div>
        <div class="flex justify-between text-sm">
          <span class="text-gray-600">Confirmed</span>
          <span class="font-medium text-green-600">{{ appointmentStats().confirmed }}</span>
        </div>
        <div class="flex justify-between text-sm">
          <span class="text-gray-600">Completed</span>
          <span class="font-medium text-blue-600">{{ appointmentStats().completed }}</span>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-sm font-medium text-gray-500">Patient Growth</h3>
        <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      </div>
      <p class="text-3xl font-bold text-gray-900">{{ patients().length }}</p>
      <p class="text-sm text-green-600 mt-2">
        <span class="inline-flex items-center">
          <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L6.707 7.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
          </svg>
          +12% this month
        </span>
      </p>
    </div>

    <div class="card">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-sm font-medium text-gray-500">Revenue Trend</h3>
        <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
        </svg>
      </div>
      <p class="text-3xl font-bold text-gray-900">
        ${{ totalRevenue().toLocaleString() }}
      </p>
      <p class="text-sm text-green-600 mt-2">
        <span class="inline-flex items-center">
          <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L6.707 7.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
          </svg>
          +8% from last month
        </span>
      </p>
    </div>
  </div>

  <div class="card">
    <h3 class="text-lg font-semibold text-gray-900 mb-6">Monthly Revenue</h3>
    <div class="space-y-4">
      @if (monthlyRevenue().length === 0) {
        <p class="text-gray-500 text-center py-8">No revenue data available</p>
      } @else {
        @for (item of monthlyRevenue(); track item.month) {
          <div>
            <div class="flex justify-between items-center mb-2">
              <span class="text-sm font-medium text-gray-700">{{ item.month }}</span>
              <span class="text-sm font-semibold text-gray-900">${{ item.revenue.toLocaleString() }}</span>
            </div>
            <div class="w-full bg-gray-200 rounded-full h-2">
              <div class="bg-primary-600 h-2 rounded-full" 
                   [style.width.%]="getRevenuePercentage(item.revenue)">
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>

